import { SessionPersistence, SessionStoragePersistence } from '@ibe/services';
import useConfig from './useConfig';

type ReturnType<T> = {
  getSearchParams: (key: string) => T | undefined;
  setSearchParams: (key: string, searchParams: T) => void;
  clearSearchParams: () => void;
  sanitizeKey: (key: string) => string;
};

const usePersistSearchParams = <T extends {}>(): ReturnType<T> => {
  const config = useConfig();
  const session = config.sessionKeyTabsShared
    ? new SessionPersistence<Record<string, T>>()
    : new SessionStoragePersistence<Record<string, T>>();
  session.useKey(config.sessionKeySearchParams);

  const getSearchParams = (key: string): T | undefined => {
    const params = session.get();
    if (!params) {
      return undefined;
    }
    return params[sanitizeKey(key)];
  };

  const setSearchParams = (key: string, searchParams: T): void => {
    let params = session.get();
    params = { ...params, [sanitizeKey(key)]: searchParams };
    session.set(params);
  };

  const clearSearchParams = (): void => {
    session.clear();
  };
  const sanitizeKey = (key: string): string => {
    return key.replace(/[^a-zA-Z ]/g, '');
  };

  return { getSearchParams, setSearchParams, clearSearchParams, sanitizeKey };
};

export default usePersistSearchParams;
